/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	ThankYouScreenBulkResetPathParams,
	ThankYouScreenBulkResetResponse,
} from '../types/ThankYouScreenBulkReset'

/**
 * POST /campaigns/:campaign/thank-you-screens/reset
 * @see backend/nexus/modules/Form/Http/Controllers/ThankYouScreenController.php ThankYouScreenController::bulkReset
 */
export async function thankYouScreenBulkReset(
	campaign: ThankYouScreenBulkResetPathParams['campaign'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ThankYouScreenBulkResetResponse>> {
	return axiosInstance.post(`/campaigns/${campaign}/thank-you-screens/reset`, undefined, config)
}
